import { getFilesFromFolder } from '@/utils/getFilesFromFolder';

const requireModule = require.context('.', false, /\.ts$/);

export default getFilesFromFolder(requireModule);
